var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6781 2.13845L12.6781 2.13848C13.0675 2.44378 13.2973 2.80689 13.3721 3.14804C13.4436 3.47431 13.3842 3.82028 13.1198 4.15787C13.1198 4.15794 13.1197 4.158 13.1197 4.15806L4.71123 14.8855L4.71092 14.8859C4.54229 15.1014 4.28464 15.2288 4.01019 15.2319L4.00916 15.2319L1.24883 15.2673L0.623697 12.5776L0.623569 12.5771C0.561616 12.3117 0.623152 12.0308 0.792957 11.8129C0.793074 11.8128 0.793191 11.8126 0.793308 11.8125L9.20087 1.08624C9.20093 1.08616 9.20099 1.08608 9.20105 1.086C9.46521 0.749568 9.78716 0.60899 10.1217 0.600418C10.4713 0.591461 10.879 0.727729 11.268 1.03272C11.268 1.03273 11.2681 1.03274 11.2681 1.03275L12.6781 2.13845Z",
    stroke: "#606C80",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 3.68408L11.0528 5.89461",
    stroke: "#606C80",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/EditUser.fdbbf57bcd732046c1add4bbacfb6054.svg";
export { ForwardRef as ReactComponent };